import {
  TAG_LIST_GET_SUCCESS,
  TAG_CREATE_SUCCESS,
  TAG_UPDATE_SUCCESS,
  TAG_DELETE_SUCCESS,
} from './type'

const initialState = {
  list: [],
}

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case TAG_LIST_GET_SUCCESS:
      return { ...state, list: action.payload || [] }
    case TAG_CREATE_SUCCESS: {
      const tag = action.payload
      if (!tag) return state
      const exists = state.list.some(t => t.id === tag.id)
      const merged = exists
        ? state.list.map(t => (t.id === tag.id ? tag : t))
        : [...state.list, tag]
      return {
        ...state,
        list: [...merged].sort((a, b) =>
          (a.name || '').localeCompare(b.name || ''),
        ),
      }
    }
    case TAG_UPDATE_SUCCESS: {
      const tag = action.payload
      if (!tag) return state
      return {
        ...state,
        list: state.list
          .map(t => (t.id === tag.id ? { ...t, ...tag } : t))
          .sort((a, b) => (a.name || '').localeCompare(b.name || '')),
      }
    }
    case TAG_DELETE_SUCCESS:
      return {
        ...state,
        list: state.list.filter(t => t.id !== action.payload),
      }
    default:
      return state
  }
}
